import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateField from "../../../components/Fields/DateField";
import NumberField from "../../../components/Fields/NumberField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import PriceTrancheModel from "../../../models/PriceTrancheModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    priceTrancheId: number
}

const EditPriceTranchePopup: React.FC<Props> = ({ show, onHide, priceTrancheId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<PriceTrancheModel>();

    useEffect(() => {
        getFormData();
    }, [])

    function getFormData() {
        DataService
            .get<PriceTrancheModel>(`api/v1/PriceTranches/${priceTrancheId}`)
            .then(response => { setFormData(response); })
            .catch(e => handleException(e));
    }

    function submit() {
        if (formData) {
            DataService
                .update<PriceTrancheModel>(`api/v1/PriceTranches`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'quantityFrom', label: 'Volume from', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'quantityTo', label: 'Volume to', labelSize: 2 },
            { name: 'beginDate', label: 'From', labelSize: 2, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Until', labelSize: 2, validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Edit volume'} >
            <Popup.Body>
                <NumberField {...getFieldProps('quantityFrom')} />
                <NumberField {...getFieldProps('quantityTo')} />
                <DateField {...getFieldProps('beginDate')} />
                <DateField {...getFieldProps('endDate')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default EditPriceTranchePopup;